import React from 'react';
import { makeStyles } from '@material-ui/core';
import PreviewDialog from '../PreviewDialog';

const useStyles = makeStyles((theme) => ({
  container: {
    cursor: 'pointer',
  },
}));

export default function ImgWithPreviewDialog({ url, imgClassName, onLoad = () => {}}) {
  const classes = useStyles();
  const [showPreviewDialog, setShowPreviewDialog] = React.useState(false);

  return (
    <div className={classes.container}>
      <img
        src={url}
        className={imgClassName ? imgClassName : {}}
        onKeyDown={ () => {}}
        onClick={() => setShowPreviewDialog(true)}
        alt="img_with_preview"
        onLoad={onLoad}
      />
      <PreviewDialog previewUrl={url} showDialog={showPreviewDialog} closePop={() => setShowPreviewDialog(false)} />
    </div>
  );
}
